import { useState } from "react";
import useMerchantPortalAxios from "../utils/axios";
import { useDispatch } from "react-redux";
import useResponse from "../app/useResponse";
import { settingData } from "../features/transferAbroadDetailsSlice";

const TransferAbroadAPI = () => {
  const [transferAbroadData, setTransferAbroadData] = useState([]);
  const [transferLoading, setTransferLoading] = useState(true);
  const [totalNbOfPage, setTotalNbOfPage] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const MerchantPortalAxios = useMerchantPortalAxios();

  const { errorResponse } = useResponse();
  const dispatch = useDispatch();

  const Corridors = async () => {
    try {
      const res = await MerchantPortalAxios.post(
        "/v1/InternationalTransfer/corridors",
        {
          SessionID: sessionStorage.getItem("SessionID"),
        }
      );
      return res.data.Payload;
    } catch (error) {
      console.error("Error fetching corridors:", error);
      throw error;
    }
  };

  const TransferCountries = async () => {
    try {
      const res = await MerchantPortalAxios.post(
        "/v1/InternationalTransfer/transfer-countries",
        {
          SessionID: sessionStorage.getItem("SessionID"),
        }
      );
      return res.data.Payload;
    } catch (error) {
      console.error("Error fetching corridors:", error);
      throw error;
    }
  };

  const CorridorCurrency = async (corridorID, countryID) => {
    try {
      const res = await MerchantPortalAxios.post(
        "/v1/InternationalTransfer/corridor-currency",
        {
          SessionID: sessionStorage.getItem("SessionID"),
          CorridorID: corridorID,
          CountryID: countryID,
        }
      );
      return res.data.Payload;
    } catch (error) {
      console.error("Error fetching corridor currency:", error);
      throw error;
    }
  };

  const CountryTransferTypes = async (countryID, currencyID, amount) => {
    try {
      const res = await MerchantPortalAxios.post(
        "/v1/InternationalTransfer/country-transfer-types",
        {
          SessionID: sessionStorage.getItem("SessionID"),
          CountryID: countryID,
          CurrencyID: currencyID,
          Amount: amount,
        }
      );
      return res.data.Payload;
    } catch (error) {
      console.error("Error fetching corridor currency", error);
      throw error;
    }
  };

  const InternationalTransferFields = async (
    corridorID,
    countryID,
    currencyID,
    transferTypeID
  ) => {
    try {
      const res = await MerchantPortalAxios.post(
        "/v1/InternationalTransfer/international-transfer-fields",
        {
          SessionID: sessionStorage.getItem("SessionID"),
          CorridorID: corridorID,
          CountryID: countryID,
          CurrencyID: currencyID,
          TransferTypeID: transferTypeID,
        }
      );
      return res.data.Payload;
    } catch (error) {
      console.error("Error fetching corridor currency", error);
      throw error;
    }
  };

  const InitInternationalTransfer = async (
    ListDataFields,
    corridorID,
    amount,
    currency,
    countryID,
    transferTypeID
  ) => {
    try {
      const response = await MerchantPortalAxios.post(
        "/v1/InternationalTransfer/init-international-transfer",
        {
          SessionID: sessionStorage.getItem("SessionID"),
          ListDataFields,
          CorridorID: corridorID,
          Amount: amount,
          currency: currency,
          CountryID: countryID,
          TransferTypeID: transferTypeID,
        }
      );
      return response.data.Payload;
    } catch (error) {
      errorResponse(error);
    }
  };

  const ExecuteInternationalTransfer = async (payload) => {
    const res = await MerchantPortalAxios.post(
      `/v1/InternationalTransfer/execute-international-transfer`,
      payload
    );
    return res.data.Payload;
  };

  const ListInternationalTransfer = async (pageNb, dateFrom, dateTo) => {
    setTransferLoading(true);
    await MerchantPortalAxios.post(
      "/v1/InternationalTransfer/list-international-transfer",
      {
        SessionID: sessionStorage.getItem("SessionID"),
        Page: pageNb,
        PageSize: 10,
        DateFrom: dateFrom,
        DateTo: dateTo,
      }
    )
      .then((res) => {
        setTransferAbroadData(res.data.Payload.InternationalTransfers);
        if (res.data.Payload.length === 0) {
          setTotalNbOfPage(0);
          setTotalCount(0);
        } else {
          setTotalNbOfPage(res.data.Payload.Page);
          setTotalCount(res.data.Payload.PagesCount || 0);
        }
      })
      .finally(() => {
        setTransferLoading(false);
      });
  };

  const TransferHistory = async (dateFrom, dateTo, lastIds = {}) => {
    setTransferLoading(true);

    try {
      const res = await MerchantPortalAxios.post(
        "/v1/InternationalTransfer/transfer-history",
        {
          SessionID: sessionStorage.getItem("SessionID"),
          DateFrom: dateFrom,
          DateTo: dateTo,
          PageSize: 10,
          LastIds: lastIds,
        }
      );

      const rows = res?.data?.Rows || [];
      dispatch(settingData({ field: "transferAbroadData", value: rows }));

      setTransferAbroadData(rows);
      setTotalCount(rows.length);
      setHasMore(rows.length > 0);

      return rows;
    } catch (error) {
      console.log("TransferHistory error", error);
      return [];
    } finally {
      setTransferLoading(false);
    }
  };

  return {
    Corridors,
    CorridorCurrency,
    CountryTransferTypes,
    InternationalTransferFields,
    InitInternationalTransfer,
    ExecuteInternationalTransfer,
    ListInternationalTransfer,
    totalCount,
    totalNbOfPage,
    transferAbroadData,
    transferLoading,
    TransferCountries,
    TransferHistory,
    hasMore,
  };
};

export default TransferAbroadAPI;
